export default {
  wrapper: {
    variants: {
      initial: {
        top: 'auto',
        transform: 'scale(0)'
      },
      active: {
        transform: 'scale(1)'
      }
    }
  },
  modalSettings: {
    base: {
      contentType: 'Body3'
    }
  }
};